import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import SocialShare from "../SocialShare/SocialShare"
import * as styles from "./SharePageModal.module.scss"
import ReactModal from "@components/global/ReactModal/ReactModal"
import Button from "@components/objects/Button/Button"
import shareOrange from "@images/icons/shareOrange.svg"

const SharePageModal = () => {
  const url = typeof window !== "undefined" && window.location.href ? window.location.href : ""

  const copyText = (e) => {
    e.preventDefault()
    e.target.elements["url"].select()
    document.execCommand("copy")
  }

  return (
    <div>
      <ReactModal
        className={styles.SharePageModal}
        button={{
          image: shareOrange,
          color: "orange",
          text: "Share",
          design: "text",
          size: "large",
        }}
        modalLabel="Share Profile"
      >
        <section>
          <header>
            <h2>Share Profile</h2>
          </header>
          <main>
            <SiteWrapper>
              <form onSubmit={(e) => copyText(e)}>
                <input name="url" type="text" readOnly value={url} />
                <Button text="Copy" type="submit" />
              </form>
              <p>Or share using one of these channels:</p>
              <SocialShare url={url} />
            </SiteWrapper>
          </main>
        </section>
      </ReactModal>
    </div>
  )
}

export default SharePageModal
